"use client";

import { useEffect } from "react";

import type { ModalBehaviorOptions } from "./modal-behavior";
import { useModalContext } from "./modal-context";

export const preventClosingModalIf = (condition: boolean, fn: () => void, elseFn?: () => void) => {
  return () => {
    if (!condition) {
      elseFn?.();
      return { shouldKeepModalOpen: false };
    }
    fn();
    return { shouldKeepModalOpen: true };
  };
};

export const useModalBehavior = (options: ModalBehaviorOptions) => {
  const { setBehaviorOptions } = useModalContext();

  useEffect(() => {
    setBehaviorOptions(options);
  }, [options, setBehaviorOptions]);
};
